import { useFormContext } from 'react-hook-form'
import { useCalculatedAmounts } from 'src/hooks/useCalculatedAmounts'
import { InvoiceFormInputs } from '../InvoiceEditForm'
const scale = 0.8
export const BillingAmount: React.FC = () => {
  const { watch } = useFormContext<InvoiceFormInputs>()
  const { calculated_amount } = useCalculatedAmounts(
    watch('items'),
    watch('taxSettings')
  )
  return (
    <>
      <text
        x={36 / scale}
        y={200 / scale}
        fill="#0D0D0D"
        fontSize={'10px'}
        transform={`scale(${scale})`}
      >
        下記の通りご請求申し上げます
      </text>
      <text x="40" y="218" fill="#0D0D0D" fontSize={'10px'}>
        ご請求金額
      </text>
      <text
        x="210"
        y="218"
        fill="#0D0D0D"
        fontSize={'10px'}
        fontWeight={'bold'}
        textAnchor="end"
      >
        ¥
        {calculated_amount?.calculated_amount.total_amount?.toLocaleString() ||
          0}
      </text>
      <line x1="36" y1="226.5" x2="226" y2="226.5" stroke="black" />
    </>
  )
}
